import styled from '@emotion/styled';

export const OuterWrap = styled.div`
  /* @media (min-width: 1260px) {
    display: flex;
  } */
`;
export const HomeScreen = styled.div`
  margin: 24px 16px;
  @media (min-width: 768px) {
    margin: 48px 40px;
  }
  @media (min-width: 1024px) {
    margin: 48px auto 0;
    width: 900px;
  }
  @media (min-width: 1630px) {
    width: 952px;
  }
`;

export const TopBarStyles = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0bcb4;
  justify-content: space-between;
  padding: 0 16px;
  position: relative;
  height: 70px;
  @media (min-width: 768px) {
    padding: 0 40px;
  }
  @media (min-width: 1024px) {
    padding: 0 70px;
  }
  @media (min-width: 1700px) {
    padding: 0 230px;
  }
`;
export const Logout = styled.div`
  height: 80px;
  width: 160px;
  background-color: white;
  /* display: flex; */
  align-items: center;
  position: absolute;
  flex-direction: column;
  right: 0;
  top: 60px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  z-index: 500;
  @media (min-width: 768px) {
    flex-direction: initial;
  }
  @media (min-width: 1024px) {
    width: 216px;
    height: 80px;
  }
`;
export const LogoutStyles = styled.span`
  height: 40px;
  width: 100%;
  padding-left: 24px;
  display: flex;
  align-items: center;
  :hover {
    background-color: #eae8e5;
  }
`;
export const NewOrderStyles = styled.div`
  height: 40px;
  width: 100%;
  padding-left: 24px;
  display: flex;
  align-items: center;
  :hover {
    background-color: #eae8e5;
  }
  @media (min-width: 768px) {
    display: none;
  }
`;
export const DropdownStyles = styled.div`
  background: #ffffff;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14),
    0px 1px 3px rgba(0, 0, 0, 0.12);
  width: 148px;
  padding: 20px;
  position: absolute;
  right: 16px;
  top: 60px;
  z-index: 50;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const MenuIconStyles = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
export const IconStyles = styled.div`
  display: flex;
  align-items: center;
  .add_new_order_button {
    text-transform: uppercase;
    font-size: 12px;
    /* text-decoration: underline; */
    font-weight: bold;
    cursor: pointer;
    transition: all 0.1s;
    margin-right: 16px;
    color:#444;
    :last-of-type {
      margin-right: 0;
    }
    :hover {
      /* color: #93918f; */
      text-decoration: underline;
      color:#333;
    }
  }
  @media (max-width: 767px) {
    display: none;
  }
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }
`;
export const TopInfo = styled.div`
  @media (max-width: 1023px) {
    display: none;
  }
  @media (min-width: 1024px) {
    position: relative;
    display: flex;
    margin-left: 30px;
  }
`;
export const SearchInputMobile = styled.div`
  display: flex;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const SearchInputDesktop = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
  }
`;
export const CardLayout = styled.div`
  display: block;
  margin-bottom: 32px;
  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    margin-bottom: 48px;
    /* max-width:250px; */
  }
  @media (min-width: 1024px) {
    max-width: 900px;
  }
  @media (min-width: 1630px) {
    max-width: 952px;
  }
`;
export const ButtonStyles = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 56px;
  @media (min-width: 1260px) {
    margin-top: 20px;
  }
`;
